// ScaledGroup — scales its children as ONE visual group (photo-style).
// Replaces CSS `zoom` for the v2 hero text-size control: `zoom` reflows the
// text (iOS re-wraps it into a squished column), while transform:scale keeps
// the layout/wrapping identical at every size — the group simply shrinks or
// grows. Wrapper height tracks natural-height × scale so the page flow stays
// tight. For scale > 1 the inner lays out at 100/s% width so the enlarged
// group still fits the container.
import { useEffect, useRef, useState } from "react";

export function ScaledGroup({ scale = 1, className = "", children, ...rest }) {
  const innerRef = useRef(null);
  const [h, setH] = useState(null);
  const s = Number.isFinite(+scale) && +scale > 0 ? +scale : 1;
  useEffect(() => {
    const el = innerRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => setH(el.offsetHeight));
    ro.observe(el);
    setH(el.offsetHeight);
    return () => ro.disconnect();
  }, [s]);
  if (s === 1) return <div className={className} {...rest}>{children}</div>;
  const wide = s > 1;
  return (
    <div className={className} {...rest}
      style={{ height: h != null ? Math.round(h * s) : undefined, overflow: "visible" }}>
      <div ref={innerRef}
        style={{
          display: "flow-root",
          width: wide ? `${100 / s}%` : "100%",
          marginLeft: wide ? `${(100 - 100 / s) / 2}%` : undefined,
          transform: `scale(${s})`,
          transformOrigin: "top center",
        }}>
        {children}
      </div>
    </div>
  );
}
